// Bad Beat Jackpot rule data shared by the big-screen display (summary) and the
// scan-to-open rules page (full detail), so the two never drift apart.

// The qualifying hand drops one rank per 1,00,000 the jackpot grows; from 8,00,000 up it
// stays at Aces Full of Kings while the pool keeps accumulating.
export const QUALIFYING_LEVELS = [
  { min: 100000, label: "1,00,000", hand: "Quad Eights (8888x)" },
  { min: 200000, label: "2,00,000", hand: "Quad Sevens (7777x)" },
  { min: 300000, label: "3,00,000", hand: "Quad Sixes (6666x)" },
  { min: 400000, label: "4,00,000", hand: "Quad Fives (5555x)" },
  { min: 500000, label: "5,00,000", hand: "Quad Fours (4444x)" },
  { min: 600000, label: "6,00,000", hand: "Quad Threes (3333x)" },
  { min: 700000, label: "7,00,000", hand: "Quad Twos (2222x)" },
  { min: 800000, label: "8,00,000+", hand: "Aces Full of Kings (AAAKK)" },
];

// The jackpot starts at 1,00,000, so anything below the first step still uses its hand.
export const qualifyingLevelFor = (amount) => {
  const amt = Number(amount) || 0;
  let level = QUALIFYING_LEVELS[0];
  for (const l of QUALIFYING_LEVELS) if (amt >= l.min) level = l;
  return level;
};

export const PAYOUT_SPLIT = [
  { pct: 45, label: "Losing Hand" },
  { pct: 25, label: "Winning Hand" },
  { pct: 25, label: "Table Share" },
  { pct: 5, label: "Staff Gratuity" },
];

export const CONTRIBUTION = { amount: "100", potOver: "3,000" };
